import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Hash } from "lucide-react";

const reduceNumber = (n) => {
  while (![11, 22, 33].includes(n) && n > 9) {
    n = String(n).split("").reduce((a, d) => a + parseInt(d, 10), 0);
  }
  return n;
};

const Numerology = ({ meanings }) => {
  const [dob, setDob] = useState("");
  const [result, setResult] = useState(null);

  const compute = () => {
    if (!dob) return;
    const digits = dob.replace(/[^0-9]/g, "");
    const sum = digits.split("").reduce((a, d) => a + parseInt(d, 10), 0);
    const lifePath = reduceNumber(sum);
    setResult({ lifePath, meaning: meanings[String(lifePath)] || "" });
  };

  return (
    <div className="space-y-3" data-testid="numerology-tool">
      <label className="text-sm text-ink-2">Your date of birth</label>
      <div className="flex gap-2">
        <Input type="date" value={dob} onChange={(e) => setDob(e.target.value)} className="rounded-2xl bg-white border-linen-3 h-12" data-testid="numerology-dob" />
        <Button onClick={compute} className="rounded-full bg-brand hover:bg-brand-hover text-linen px-6" data-testid="numerology-compute">Reveal</Button>
      </div>
      {result && (
        <div className="bg-white rounded-2xl border border-linen-3 p-6 text-center mt-2" data-testid="numerology-result">
          <span className="w-16 h-16 rounded-full bg-calm flex items-center justify-center mx-auto mb-3"><Hash className="w-7 h-7 text-brand" /></span>
          <p className="text-xs text-accent uppercase tracking-wide">Your Life Path Number</p>
          <p className="font-serif text-6xl text-brand leading-none mt-1">{result.lifePath}</p>
          <p className="text-ink-2 leading-relaxed mt-4">{result.meaning}</p>
          <p className="text-xs text-ink-mute mt-4">Numerology is a reflective lens for self-exploration, not a prediction.</p>
        </div>
      )}
    </div>
  );
};

export default Numerology;
